import { useSelector } from "react-redux";
import { BASENAME } from "../../../utils/basename";

const MessaggioKitManodopera = () => {
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  return (
    <div className="w-full relative flex items-center bg-yellow-500 text-white text-sm font-opensanssemibold mt-8 pl-4 sm:pl-16 pr-3 py-2">
      <img
        src={BASENAME + "/images/warning.svg"}
        width="44"
        height="44"
        className="flex-start self-start sm:absolute sm:left-3 mr-3 sm:mr-0"
        alt="Avviso Kit Manodopera"
      />
      <span>{genericheTranslation.messaggiokitmanodopera.itemName}</span>
    </div>
  );
};

export default MessaggioKitManodopera;
